import { Action } from '@ngrx/store';
import { DirectorSearchFilter } from '../../models/directorSearchFilter';

export enum EPortalDirectorsListActions {
  SetSearchFilter = '[Portal Directors List] SET SEARCH FILTER',
  SetPagination = '[Portal Directors List] SET PAGINATION',
  SetSort = '[Portal Directors List] SET SORT',
  ClearFilters = '[Portal Directors List] CLEAR FILTERS'
}

export class SetPortalDirectorsSearchFilter implements Action {
  public readonly type = EPortalDirectorsListActions.SetSearchFilter;
  constructor(public payload: DirectorSearchFilter) {}
}

export class SetPortalDirectorsPagination implements Action {
  public readonly type = EPortalDirectorsListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetPortalDirectorsSort implements Action {
  public readonly type = EPortalDirectorsListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearPortalDirectorsFilters implements Action {
  public readonly type = EPortalDirectorsListActions.ClearFilters;
}

export type PortalDirectorsListActions =
  | SetPortalDirectorsSearchFilter
  | SetPortalDirectorsPagination
  | SetPortalDirectorsSort
  | ClearPortalDirectorsFilters;
